"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[764],{

/***/ 15702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ getDisplayCouponsByEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);

var isApplicableByGoodsPrice = function(coupon, adtPrice) {
    return coupon.goodsPriceCd === null || coupon.goodsPriceCd === "TOT" || coupon.goodsPriceCd === "PER" && adtPrice != null && Number(coupon.goodsPriceFr) < Number(adtPrice);
}; // 상품가 1인당 가격이 상품가보다 작은경우
var pickExclusiveCoupon = function(coupons, getDiscount) {
    if (coupons.length === 0) return undefined;
    return coupons.reduce(function(best, current) {
        var bestAmt = getDiscount(best);
        var currentAmt = getDiscount(current);
        if (currentAmt !== bestAmt) return currentAmt > bestAmt ? current : best;
        var _issueFrDt;
        var bestDt = (_issueFrDt = best.issueFrDt) !== null && _issueFrDt !== void 0 ? _issueFrDt : "";
        var _issueFrDt1;
        var currentDt = (_issueFrDt1 = current.issueFrDt) !== null && _issueFrDt1 !== void 0 ? _issueFrDt1 : "";
        if (currentDt !== bestDt) return currentDt > bestDt ? current : best;
        return best;
    });
};
var sortByGoodsPriceFr = function(coupons) {
    var nullList = coupons.filter(function(c) {
        return c.goodsPriceFr === null;
    });
    var valueList = coupons.filter(function(c) {
        return c.goodsPriceFr !== null;
    }).sort(function(a, b) {
        return Number(b.goodsPriceFr) - Number(a.goodsPriceFr);
    });
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(nullList).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(valueList));
};
/** 상세 페이지 사용 가능 쿠폰 노출 목록 */ var getDisplayCouponsByEvent = function(coupons, adtPrice) {
    if (!coupons) return [];
    var filtered = coupons.filter(function(c) {
        return isApplicableByGoodsPrice(c, adtPrice);
    });
    var multiUse = filtered.filter(function(c) {
        return c.multiUseYn === "Y";
    });
    var exclusive = filtered.filter(function(c) {
        return c.multiUseYn !== "Y";
    });
    var pickedAmt = pickExclusiveCoupon(exclusive.filter(function(c) {
        return c.discDiviCd === "M";
    }), function(c) {
        return Number(c.discAmt);
    });
    var pickedRate = pickExclusiveCoupon(exclusive.filter(function(c) {
        return c.discDiviCd !== "M";
    }), function(c) {
        return Number(c.discRate);
    });
    return sortByGoodsPriceFr((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(multiUse).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(pickedAmt ? [
        pickedAmt
    ] : []), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(pickedRate ? [
        pickedRate
    ] : [])));
};
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 40198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30202);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32423);
/* harmony import */ var _QUERIES_account_useCustomerMe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38186);







var withWishList = function(WrappedComponent) {
    return function(props) {
        var ref, ref1;
        var _isActive = props.isActive, isActive = _isActive === void 0 ? false : _isActive, _evCd = props.evCd, evCd = _evCd === void 0 ? "" : _evCd, _link = props.link, link = _link === void 0 ? "" : _link, diviCd = props.diviCd, _wishNo = props.wishNo, wishNo = _wishNo === void 0 ? "" : _wishNo, addConfirm = props.addConfirm, removeConfirm = props.removeConfirm;
        var goodsCd = evCd.split("-")[0];
        var goodsTp = evCd.substring(0, 1);
        /** 로그인 */ var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQueryClient */ .NL)();
        /** 로그인 */ var signin = (0,_QUERIES_account_useCustomerMe__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
        var webCustNo = ((ref = signin.data) === null || ref === void 0 ? void 0 : ref.body.webCustNo) || "";
        var isSignin = ((ref1 = signin.data) === null || ref1 === void 0 ? void 0 : ref1.body.nonUser) === false;
        var addWish = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var result, _tmp, _tmp1;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            return [
                                4,
                                (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_tmp.url = "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ENV_ESSENTIAL_API_BASEPATH */ .Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList"), _tmp.method = "POST", _tmp.data = {
                                    webCustNo: webCustNo,
                                    goodsCd: goodsCd,
                                    goodsNm: "",
                                    evCd: evCd,
                                    diviCd: diviCd,
                                    imageThum: "",
                                    link: "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ENV_PRODUCT_URL */ .Z.ENV_PRODUCT_URL).concat(link),
                                    itemCategoryCode: "".concat(goodsTp === "K" ? "D" : "P"),
                                    cityCode: "",
                                    latestAmount: ""
                                }, _tmp)).catch(function(e) {
                                    throw new Error();
                                })
                            ];
                        case 1:
                            result = _state.sent();
                            _tmp1 = {};
                            if (result.data.code === "0000") {
                                MessageUtil.alert("찜한 상품으로 등록 되었습니다.");
                                queryClient.refetchQueries((_tmp1.queryKey = [
                                    "useWishlist"
                                ], _tmp1.type = "active", _tmp1));
                            } else {
                                throw new Error();
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function addWish() {
                return _ref.apply(this, arguments);
            };
        }();
        var removeWish = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var result, _tmp, _tmp1;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!wishNo) return [
                                2
                            ];
                            _tmp = {};
                            return [
                                4,
                                (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_tmp.url = "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ENV_ESSENTIAL_API_BASEPATH */ .Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList"), _tmp.method = "DELETE", _tmp.data = {
                                    wishList: [
                                        {
                                            productWishId: wishNo,
                                            webCustNo: webCustNo,
                                            evCd: evCd,
                                            goodsCd: goodsCd,
                                            itemCategoryCode: "P"
                                        }
                                    ]
                                }, _tmp)).catch(function(e) {
                                    throw new Error();
                                })
                            ];
                        case 1:
                            result = _state.sent();
                            _tmp1 = {};
                            if (result.data.code === "0000") {
                                MessageUtil.alert("찜한 상품이 삭제 되었습니다.");
                                queryClient.refetchQueries((_tmp1.queryKey = [
                                    "useWishlist"
                                ], _tmp1.type = "active", _tmp1));
                            } else {
                                throw new Error();
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function removeWish() {
                return _ref.apply(this, arguments);
            };
        }();
        var wish = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(e) {
                var isConfirm, isConfirm1;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!!isActive) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                MessageUtil.confirm("찜한 상품으로 등록하시겠습니까?")
                            ];
                        case 1:
                            isConfirm = _state.sent();
                            if (isConfirm) {
                                addWish();
                                typeof addConfirm === "function" && addConfirm(e);
                            }
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                MessageUtil.confirm("찜한 상품을 삭제하시겠습니까?")
                            ];
                        case 3:
                            isConfirm1 = _state.sent();
                            if (isConfirm1) {
                                removeWish();
                                typeof removeConfirm === "function" && removeConfirm(e);
                            }
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function wish(e) {
                return _ref.apply(this, arguments);
            };
        }();
        var onClick = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(e) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    try {
                        if (!evCd) throw new Error("필수 파라미터 누락");
                        if (!isSignin) {
                            MessageUtil.confirm("로그인 후 이용하실 수 있습니다. <br/>로그인하시겠습니까?", function() {
                                return LoginUtil.login();
                            });
                        } else {
                            wish(e);
                        }
                    } catch (e1) {
                        ;
                        MessageUtil.alert("오류가 발생하였습니다. <br/>".concat(e1));
                    }
                    return [
                        2
                    ];
                });
            });
            return function onClick(e) {
                return _ref.apply(this, arguments);
            };
        }();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
                onClick: onClick,
                isActive: props.isActive
            })
        });
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withWishList);


/***/ }),

/***/ 61817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




var key = "useWishlist";
/** ```
 * 위시리스트 조회
 *  `/customer/wishList?webCustNo={webCustNo}`
 * parameter
 * ```*/ var getPath = function(webCustNo) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_ESSENTIAL_API_BASEPATH */ .Z.ENV_ESSENTIAL_API_BASEPATH, "/api/customer/wishList?webCustNo=").concat(webCustNo);
};
/** ```
 * 위시리스트 조회
 *   `/customer/wishList?webCustNo={webCustNo}`
 * parameter
 * ```*/ var useWishlist = function(webCustNo, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(webCustNo)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(webCustNo)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useWishlist);



/***/ }),

/***/ 95134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 공통 코드 조회
 *   `/esntl/common/code/${cmmnGrpCode}`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/ var key = "useCode";
var getPath = function(cmmnGrpCode) {
    if (!cmmnGrpCode) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/portal/common/code/").concat(cmmnGrpCode);
};
/** ```
 * 공통 코드 조회
 *   `/esntl/common/code/${cmmnGrpCode}`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/ var usePortalCode = function(cmmnGrpCode, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(cmmnGrpCode)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(cmmnGrpCode)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (usePortalCode);



/***/ }),

/***/ 3889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var key = "useReview";
var getPath = function(goodsCd) {
    if (!goodsCd) return "";
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/portal/product/").concat(goodsCd, "/review");
};
/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useReview = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReview);



/***/ }),

/***/ 50297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




var key = "useReviewAI";
/** ```
 * 리뷰 AI 조회
 *   `/portal/product/${goodsCd}/review/ai-info`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var getPath = function(goodsCd) {
    if (!goodsCd) return "";
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/portal/product/").concat(goodsCd, "/review/ai-info");
};
/** ```
 * 리뷰 AI 조회
 *   `/portal/product/${goodsCd}/review/ai-info`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useReviewAI = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewAI);



/***/ }),

/***/ 81258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oM": function() { return /* binding */ reviewLikeAsync; }
/* harmony export */ });
/* unused harmony exports getPath, key */
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);



var key = "useReviewLike";
var getPath = function() {
    return "/bff/portal/reviewLike";
};
/** ```
 * 리뷰 좋아요 BFF
 *   `/bff/portal/reviewLike`
 * parameter
 *   `goodsCd` 상품코드
 *   `reviewId` 리뷰ID
 * ```*/ var reviewLikeAsync = function(params) {
    return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        url: getPath(),
        params: params
    });
};
/** ```
 * 리뷰 좋아요 BFF
 *   `/bff/portal/reviewLike`
 * parameter
 *   `goodsCd` 상품코드
 *   `reviewId` 리뷰ID
 * ```*/ var useReviewLike = function(params, options) {
    return useQuery(_object_spread({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return useConfigureAxios({
                url: getPath(),
                params: params
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useReviewLike)));



/***/ }),

/***/ 26163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87633);



var key = "useReviewLikeRecommender";
/** ```
 * 고객리뷰 추천 조회
 *   `/bff/portal/reviewLikeRecommender`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var getPath = function() {
    return "/bff/portal/reviewLikeRecommender";
};
/** ```
 * 고객리뷰 추천 조회
 *   `/bff/portal/reviewLikeRecommender`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useReviewLikeRecommender = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(),
                params: {
                    goodsCd: goodsCd
                }
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewLikeRecommender);



/***/ }),

/***/ 37006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sW": function() { return /* binding */ reviewReportAsync; }
/* harmony export */ });
/* unused harmony exports getPath, key */
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);



var key = "useReviewReport";
var getPath = function() {
    return "/bff/portal/reviewReport";
};
/** ```
 * 리뷰 신고하기 BFF
 *   `/bff/portal/reviewReport`
 * parameter
 *   `reportId` 리뷰ID
 *   `reportType` 신고하기 타입
 *   `reportCode` 신고하기 코드
 *   `reportContents` 신고하기 내용
 * ```*/ var reviewReportAsync = function(data) {
    return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        url: getPath(),
        method: "POST",
        data: data
    });
};
/** ```
 * 리뷰 신고하기 BFF
 *   `/bff/portal/reviewReport`
 * parameter
 *   `reportId` 리뷰ID
 *   `reportType` 신고하기 타입
 *   `reportCode` 신고하기 코드
 *   `reportContents` 신고하기 내용
 * ```*/ var useReviewReport = function(params, options) {
    return useQuery(_object_spread({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return useConfigureAxios({
                url: getPath(),
                method: "POST",
                params: params,
                data: params
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useReviewReport)));



/***/ }),

/***/ 56088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review/summary`
 * parameter
 *   `policyCodeIdHi` 공통코드 상위 ID
 * ```*/ var key = "useReviewSummary";
var getPath = function(goodsCd) {
    if (!goodsCd) return "";
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/portal/product/").concat(goodsCd, "/review/summary");
};
/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review/summary`
 * parameter
 *   `policyCodeIdHi` 공통코드 상위 ID
 * ```*/ var useReviewSummary = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(goodsCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewSummary);



/***/ }),

/***/ 93381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 쿠폰 리스트 조회 by event
 *   `/pkg/coupon/by-event/${evCd}`
 *   `/pkg/coupon/by-event/${evCd}?webCustNo=${webCustNo}`
 * parameter
 *   `evCd` 행사코드
 *   `webCustNo?` 회원 일련번호 (로그인 시)
 * ```*/ var key = "useCouponByEvent";
var getPath = function(evCd) {
    if (!evCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/coupon/by-event/").concat(evCd);
};
var useCouponByEvent = function(evCd, webCustNo, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(evCd),
            webCustNo !== null && webCustNo !== void 0 ? webCustNo : null
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(evCd),
                params: webCustNo ? {
                    webCustNo: webCustNo
                } : undefined
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 0,
        gcTime: 0
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useCouponByEvent);



/***/ }),

/***/ 46894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);




var getPath = function() {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_CHORUS_API_BASEPATH */ .Z.ENV_CHORUS_API_BASEPATH, "/cpon/issueCoupon");
};
var couponDownAsync = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(data) {
        var reuslt, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {};
                    return [
                        4,
                        (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getPath(), (_tmp.method = "POST", _tmp.data = data, _tmp))
                    ];
                case 1:
                    reuslt = _state.sent();
                    return [
                        2,
                        reuslt
                    ];
            }
        });
    });
    return function couponDownAsync(data) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (couponDownAsync);


/***/ }),

/***/ 64380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 리뷰 사진 조회
 *   `/api/bff/vimeo/videos/${vimeoId}`
 * parameter
 *   `vimeoId
 * ```*/ var key = "useReviewSummary";
var getPath = function(vimeoId) {
    if (!vimeoId) return "";
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_SUPPORT_URL */ .Z.ENV_SUPPORT_URL, "/api/bff/vimeo/videos/").concat(vimeoId);
};
/** ```
 * 리뷰 사진 조회
 *   `/api/bff/vimeo/videos/${vimeoId}`
 * parameter
 *   `vimeoId
 * ```*/ var useReviewPictures = function(vimeoId, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(vimeoId)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(vimeoId)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: 1000 * 60 * 30,
        staleTime: 1000 * 60 * 30,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useReviewPictures);



/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

}]);